import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.admin);
      toast.success(`Welcome, ${data.admin.name || "Admin"}`);
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err, "Invalid credentials"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] grain flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="relative z-10 w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/xmd-logo.png" alt="XMD" className="h-14 mx-auto mb-4" />
          <p className="font-mono-label uppercase tracking-[0.3em] text-xs text-[#D4AF37]">Staff Portal</p>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl p-7 space-y-4">
          <div>
            <span className="text-white/60 text-xs uppercase tracking-wide font-mono-label mb-1.5 block">Email</span>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0a0a0a] border-white/15" required />
          </div>
          <div>
            <span className="text-white/60 text-xs uppercase tracking-wide font-mono-label mb-1.5 block">Password</span>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0a0a0a] border-white/15" required />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-gold w-full rounded-full py-3 uppercase tracking-wide font-mono-label text-sm flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={16} /> : <Lock size={16} />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
